import React, { useState } from 'react';
import ImageUpload from './components/ImageUpload';
import FaceAnalyzer from './components/FaceAnalyzer';
import BodyAnalyzer from './components/BodyAnalyzer';
import ResultsDisplay from './components/ResultsDisplay';
import BodyResults from './components/BodyResults';
import './App.css';

function App() {
  const [image, setImage] = useState(null);
  const [analysisType, setAnalysisType] = useState(null); // 'face' or 'body'
  const [faceAnalysis, setFaceAnalysis] = useState(null);
  const [bodyAnalysis, setBodyAnalysis] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleImageSelect = (selectedImage, type) => {
    setImage(selectedImage);
    setAnalysisType(type);
    setFaceAnalysis(null);
    setBodyAnalysis(null);
  };

  const handleFaceAnalysisComplete = (result) => {
    setFaceAnalysis(result);
    setLoading(false);
  };

  const handleBodyAnalysisComplete = (result) => {
    setBodyAnalysis(result);
    setLoading(false);
  };

  const resetAll = () => {
    setImage(null);
    setAnalysisType(null);
    setFaceAnalysis(null);
    setBodyAnalysis(null);
  };

  return (
    <div className="app">
      <header className="header">
        <div className="logo-container">
          <img src="/logo.png" alt="Face & Style" className="app-logo" />
        </div>
        <p className="tagline">AI-Powered Style & Beauty Recommendations</p>
        <div className="analysis-toggle">
          <button 
            className={`toggle-btn ${analysisType === 'face' ? 'active' : ''}`}
            onClick={() => setAnalysisType('face')}
          >
            💇 Face & Hair
          </button>
          <button 
            className={`toggle-btn ${analysisType === 'body' ? 'active' : ''}`}
            onClick={() => setAnalysisType('body')}
          >
            👔 Body & Outfit
          </button>
        </div>
      </header>

      <main className="main">
        {!image && (
          <ImageUpload onImageSelect={handleImageSelect} selectedType={analysisType} />
        )}

        {image && analysisType === 'face' && !faceAnalysis && !loading && (
          <FaceAnalyzer 
            image={image} 
            onAnalysisComplete={handleFaceAnalysisComplete}
            onLoadingChange={setLoading}
          />
        )}

        {image && analysisType === 'body' && !bodyAnalysis && !loading && (
          <BodyAnalyzer 
            image={image} 
            onAnalysisComplete={handleBodyAnalysisComplete}
            onLoadingChange={setLoading}
          />
        )}

        {loading && (
          <div className="loading">
            <div className="loading-logo">
              <img src="/logo.png" alt="Face & Style" className="pulse-logo" />
            </div>
            <p className="loading-text">Analyzing your {analysisType === 'face' ? 'face shape' : 'body type'}...</p>
            <p className="loading-subtext">Detecting proportions and features</p>
          </div>
        )}

        {faceAnalysis && analysisType === 'face' && (
          <ResultsDisplay 
            analysis={faceAnalysis} 
            image={image}
            onReset={resetAll}
          />
        )}

        {bodyAnalysis && analysisType === 'body' && (
          <BodyResults 
            analysis={bodyAnalysis} 
            image={image}
            onReset={resetAll}
          />
        )}
      </main>

      <footer className="footer">
        <img src="/logo.png" alt="Face & Style" className="footer-logo" />
        <p>Your photos are processed in your browser and never stored on our servers.</p>
        <div className="affiliate-disclosure">
          This site contains affiliate links. We may earn a commission if you purchase through our recommendations.
        </div>
      </footer>
    </div>
  );
}

export default App;